/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NutritionEnteralDietViewFragmentAliases {
  CONTEXTUAL_BAR_ENTERAL_DIET_VIEW = 'contextual-bar-enteral-diet-view',
  FIELD_ADMINISTRATION = 'field-administration',
  FIELD_BAG_VOLUME_ML = 'field-bag-volume-ml',
  FIELD_DURATION = 'field-duration',
  FIELD_DURATION_H_MIN = 'field-duration-h-min',
  FIELD_END_DATE = 'field-end-date',
  FIELD_ENTERAL_DIET = 'field-enteral-diet',
  FIELD_HOURS = 'field-hours',
  FIELD_INFUSION_RATE = 'field-infusion-rate',
  FIELD_INFUSION_RATE_UNIT_OF_MEASUREMENT = 'field-infusion-rate-unit-of-measurement',
  FIELD_INTERVAL = 'field-interval',
  FIELD_ITEM = 'field-item',
  FIELD_ITEM_DOSE = 'field-item-dose',
  FIELD_ITEM_UNIT_MEASURE = 'field-item-unit-measure',
  FIELD_JUSTIFICATION = 'field-justification',
  FIELD_NUTRITION = 'field-nutrition',
  FIELD_NUTRITION_ENTERAL_ORIENTATION = 'field-nutrition-enteral-orientation',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_PRESCRIBER_DATE = 'field-prescriber-date',
  FIELD_PRESCRIBER_NAME = 'field-prescriber-name',
  FIELD_ROUTE = 'field-route',
  FIELD_STAGE_INFUSION_DURATION = 'field-stage-infusion-duration',
  FIELD_START_DATE = 'field-start-date',
  FIELD_SUCTION_DEVICE = 'field-suction-device',
  FIELD_TOTAL_VOLUME = 'field-total-volume',
  FORM_ADDITIONAL_INFORMATION = 'form-additional-information',
  FORM_ADMINISTRATION_INFORMATION = 'form-administration-information',
  FORM_MAIN_INFORMATIONS = 'form-main-informations',
  FORM_PERIOD_OF_VALIDITY = 'form-period-of-validity',
  FRAGMENT_REFERENCE_INFORMATION_BAR_HEADER = 'fragment-reference-information-bar-header',
  INPUT_END_DATE = 'input-end-date',
  INPUT_START_DATE = 'input-start-date',
  LAYOUT_ENTERAL_DIET_VIEW = 'layout-enteral-diet-view',
  LOADER = 'loader',
  PANEL_CONTENT = 'panel-content',
  PANEL_LOADER = 'panel-loader',
  SECTION_ADDITIONAL_INFORMATION = 'section-additional-information',
  SECTION_ADMINISTRATION_INFORMATION = 'section-administration-information',
  SECTION_MAIN_INFORMATIONS = 'section-main-informations',
  SECTION_PERIOD_OF_VALIDITY = 'section-period-of-validity',
  SUPPRESS_HEADING_MARGIN_ADDITIONAL_INFORMATION = 'suppress-heading-margin-additional-information',
  SUPPRESS_HEADING_MARGIN_ADMINISTRATION_INFORMATION = 'suppress-heading-margin-administration-information',
  SUPPRESS_HEADING_MARGIN_MAIN_INFORMATIONS = 'suppress-heading-margin-main-informations',
  SUPPRESS_HEADING_MARGIN_PERIOD_OF_VALIDITY = 'suppress-heading-margin-period-of-validity',
  TEXT_ADMINISTRATION = 'text-administration',
  TEXT_BAG_VOLUME_ML = 'text-bag-volume-ml',
  TEXT_DURATION = 'text-duration',
  TEXT_DURATION_H_MIN = 'text-duration-h-min',
  TEXT_ENTERAL_DIET = 'text-enteral-diet',
  TEXT_HOURS = 'text-hours',
  TEXT_INFUSION_RATE = 'text-infusion-rate',
  TEXT_INFUSION_RATE_UNIT_OF_MEASUREMENT = 'text-infusion-rate-unit-of-measurement',
  TEXT_INTERVAL = 'text-interval',
  TEXT_ITEM = 'text-item',
  TEXT_ITEM_DOSE = 'text-item-dose',
  TEXT_ITEM_UNIT_MEASURE = 'text-item-unit-measure',
  TEXT_JUSTIFICATION = 'text-justification',
  TEXT_NUTRITION = 'text-nutrition',
  TEXT_NUTRITION_ENTERAL_ORIENTATION = 'text-nutrition-enteral-orientation',
  TEXT_OBSERVATION = 'text-observation',
  TEXT_PRESCRIBER_DATE = 'text-prescriber-date',
  TEXT_PRESCRIBER_NAME = 'text-prescriber-name',
  TEXT_ROUTE = 'text-route',
  TEXT_STAGE_INFUSION_DURATION = 'text-stage-infusion-duration',
  TEXT_SUCTION_DEVICE = 'text-suction-device',
  TEXT_TOTAL_VOLUME = 'text-total-volume',
}
export { NutritionEnteralDietViewFragmentAliases };
